import { ref } from 'vue'

type Size = {
    x: number;
    y: number;
}

type Interface = {
    widget:Size;
    box: Size;
}

const position = ref<Interface>({
    widget: {
        x: 0,
        y: 0
    },
    box: {
        x: 0,
        y: 0
    }
})

const sizeInterface : Interface = {
    widget: {
        x: 64,
        y: 64
    },
    box: {
        x: 730,
        y: 680
    }
}

export default function useMoveInterface () {

    const getWidthWindow = () => window.innerWidth || document.documentElement.clientWidth ||  document.body.clientWidth
    const getHeightWindow = () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

    const getWidget = () => position.value.widget
    const getBox = () => position.value.box

    function setWidget( value: Size) {
        position.value.widget = value
    }

    function setBox(value: Size) {
        position.value.box = value
    }

    function verifyPositionOpenBox() {
        const positionX = getWidthWindow()
        const positionY = getHeightWindow()
        // se a posicao atual do widget for menor que o tamanho do box
        position.value.box.y = position.value.widget.y
        position.value.box.x = position.value.widget.x

        if(position.value.widget.y < sizeInterface.box.y  ) {
            // console.log('position.value.widget.y < sizeInterface.box.y')
        }
        if((position.value.widget.x + sizeInterface.box.x) > positionX ) {
            position.value.box.x = ( positionX - sizeInterface.box.x - 1 )
        }
        if((position.value.widget.y + sizeInterface.box.y) > positionY ) {
            position.value.box.y = ( positionY - sizeInterface.box.y - 1 )
        }
    }

    return {  getBox, setBox, getWidget, setWidget, verifyPositionOpenBox }
}
